export class RatingInfo {
    rating: number;
    count: string;
    product?: string;
    quantity: number;
    /**
     * 
     * @param rating
     * @param product
     * @param quantity
     * @param count
     */
    constructor(rating: number,count: string,quantity: number,product?: string) {
        this.rating = rating;
        this.count = count;
        this.quantity = quantity;
        this.product = product;
    }
}